// extracted by mini-css-extract-plugin
export default {"root":"InviteLayout-root-f5ce55ca5e1c7d80f4f070a60e90a47b","logoContainer":"InviteLayout-logoContainer-1a8022a21303bcc838e5271a2d3e9cfc"};